import { SVGProps, Ref, forwardRef } from 'react';

export const HumanCircleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5c5.625 0 7.5 3.75 7.5 7.5s-1.875 7.5-7.5 7.5S.5 11.75.5 8 2.375.5 8 .5M4.667 6.733a.7.7 0 0 0 0 1.4h1.787l-.73 3.837a.7.7 0 0 0 1.375.261l.405-2.13h.99l.407 2.145a.7.7 0 0 0 1.375-.262l-.733-3.85h1.791a.7.7 0 0 0 0-1.4zM8 3c-.548 0-.942.185-1.195.488-.248.297-.338.682-.338 1.045s.09.747.338 1.044c.253.304.647.49 1.195.49s.942-.186 1.195-.49c.248-.297.338-.681.338-1.044s-.09-.748-.338-1.045C8.942 3.185 8.548 3 8 3"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
HumanCircleFilledSize16Glyph.displayName = 'HumanCircleFilledSize16Glyph';
